import { render, staticRenderFns } from "./PositionsSummarySection.vue?vue&type=template&id=596485ed&scoped=true"
import script from "./PositionsSummarySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PositionsSummarySection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PositionsSummarySection.vue?vue&type=style&index=0&id=596485ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596485ed",
  null
  
)

export default component.exports